import { Component, OnInit } from '@angular/core';
import { IBillingDocument } from '@dch/billing-business-logic';
import { MessageBoxTypesEnum } from '@dch/pxs-angular-design-system/src/lib/messages/message-box';
import { UtilsService } from '../services/utils.service';
import { SelectedOdbDetailsInfo } from '../models/pii.model';
import { Router } from '@angular/router';
import {
  DEFERRAL_SUCCESSFUL_NEW_DATE_PAGE,
  OVERVIEW_PAGE,
} from '../config/my-bill.constants';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectDeferralState } from 'src/app/state/selectors/deferral.selectors';
import { deferralRequest, resetDeferralData } from 'src/app/state/actions';
import { OnDestroyHookDirective } from '../common/hooks';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'my-bill-deferral-accept-new-date-page',
  templateUrl: './deferral-accept-new-date-page.component.html',
  standalone: false,
})
export class DeferralAcceptNewDatePageComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly deferralState$ = this.store.select(selectDeferralState);
  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private store: Store<ApplicationState>
  ) {
    super();
  }

  selectedOdbDetailsInfo?: SelectedOdbDetailsInfo;
  billDocument?: IBillingDocument;
  selectedNewPaymentDate: string;
  isTermsAccepted: boolean;
  paNumber?: string;
  messageBoxTypeError = MessageBoxTypesEnum.Error;

  ngOnInit() {
    const { selectedNewPaymentDate } = history.state;
    const { billDocument, billingAccountNumber } =
      this.utilsService.getDeferralDocumentInfoFromStorage();

    if (billDocument && billingAccountNumber && selectedNewPaymentDate) {
      this.billDocument = billDocument;
      this.paNumber = billingAccountNumber;
      this.selectedNewPaymentDate = selectedNewPaymentDate;
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }

    this.addSubscription(
      this.deferralState$
        .pipe(
          tap((value) => {
            if (value.isSaved) {
              this.store.dispatch(resetDeferralData());
              this.router.navigate([DEFERRAL_SUCCESSFUL_NEW_DATE_PAGE], {
                state: {
                  selectedNewPaymentDate: this.selectedNewPaymentDate,
                },
              });
            }
          })
        )
        .subscribe()
    );
  }

  saveDeferralDate(): void {
    this.store.dispatch(
      deferralRequest({
        paNumber: this.paNumber,
        invoiceReference: this.billDocument.internalDocumentId,
        requestBody: { newDueDate: this.selectedNewPaymentDate },
      })
    );
  }

  closeModal(): void {
    this.store.dispatch(resetDeferralData());
  }
}
